/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiWeightingChargerIdConnectorIdStatusPut } from '../fn/weighting/api-weighting-charger-id-connector-id-status-put';
import { ApiWeightingChargerIdConnectorIdStatusPut$Params } from '../fn/weighting/api-weighting-charger-id-connector-id-status-put';

@Injectable({ providedIn: 'root' })
export class WeightingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiWeightingChargerIdConnectorIdStatusPut()` */
  static readonly ApiWeightingChargerIdConnectorIdStatusPutPath = '/api/Weighting/{chargerId}/{connectorId}/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiWeightingChargerIdConnectorIdStatusPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWeightingChargerIdConnectorIdStatusPut$Response(params: ApiWeightingChargerIdConnectorIdStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiWeightingChargerIdConnectorIdStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiWeightingChargerIdConnectorIdStatusPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiWeightingChargerIdConnectorIdStatusPut(params: ApiWeightingChargerIdConnectorIdStatusPut$Params, context?: HttpContext): Observable<void> {
    return this.apiWeightingChargerIdConnectorIdStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
